<style lang="less" scoped>
  .form-wrapper {
    width: 280px;
  }
  .form {
    margin-top: 73px;
  }
  .login-button {
    width: 100%;
    height: 50px;
    border-top: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    color: #ff6c00;
    font-weight: bold;
  }
  .register-button {
    width: 100%;
    margin-top: 30px;
    color: #7965ef;
    border-color: #7965ef;
    background-color: #fff;
    font-weight: bold;
    &:hover, &:focus {
      color: #7965ef;
      border-color: #7965ef;
      background-color: #fff;
    }
  }
  .link-button-group {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
    color: #808080;
  }
  .link-button {
    color: #808080;
    cursor: pointer;
  }
  .link-button-divider {
    margin: 0 4px;
  }
</style>

<style lang="less">
  .sc-login-form {
    .el-input {
      &:first-of-type {
        z-index: 1;
        input.el-input__inner {
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
      &:last-of-type {
        input.el-input__inner:focus {
          border-top: 1px solid #ff6c00;
        }
        input.el-input__inner {
          border-top: 1px solid transparent;
          border-radius: 0;
        }
      }
    }
  }
</style>

<template lang="pug">
  .form-wrapper
    form.form.sc-login-form(@submit.prevent="login")
      el-input.lg(placeholder="아이디", v-model="username")
      el-input.lg(
        v-model="password",
        placeholder="비밀번호",
        type="password")
      el-button.login-button(native-type="submit") 로그인
    el-button.register-button(v-if="!hideRegister", @click="goToRegist") 기업회원가입 (입점신청)
    .link-button-group(v-if="!hideRegister")
      button.link-button(@click="openDialog('username')") 아이디
      span.link-button-divider /
      button.link-button(@click="openDialog('password')") 비밀번호 찾기

    find-account-dialog(
      :visible="visible",
      :currentTab="currentTab",
      :searchedUsername="searchedUsername",
      :sentEmail="sentEmail",
      @changeTab="changeTab",
      @searchUsername="searchUsername",
      @findPassword="findPassword",
      @close="closeDialog")
</template>

<script>
import FindAccountDialog from '@/components/FindAccountDialog.vue';

export default {
  components: {
    FindAccountDialog,
  },
  props: {
    hideRegister: {
      type: Boolean,
      default: false,
    },
    currentTab: {
      type: String,
      default: 'username', // 'username', 'password'
    },
    visible: {
      type: Boolean,
      default: false,
    },
    searchedUsername: {
      type: String,
    },
    sentEmail: {
      type: String,
    },
  },
  data() {
    return {
      username: null,
      password: null,
    };
  },
  methods: {
    login() {
      console.log('login');
      this.$emit('login', { username: this.username, password: this.password });
    },
    openDialog(tabName) {
      this.$emit('openDialog', tabName);
    },
    closeDialog() {
      this.$emit('closeDialog');
    },
    changeTab(tabName) {
      this.$emit('changeTab', tabName);
    },
    goToRegist() {
      this.$emit('goToRegist');
    },
    searchUsername(businessNumber) {
      this.$emit('searchUsername', businessNumber);
    },
    findPassword({ businessNumber, username }) {
      this.$emit('findPassword', { businessNumber, username });
    },
  },
};
</script>
